// extracted by mini-css-extract-plugin
export default {"wrapper":"x6-z","play":"y6-z"};